import { Role } from '@common/application/enums/Role';
import getAvailableRoles from '@common/application/helpers/getAvailableRoles';
import { useSession } from 'next-auth/react';

const useUserRoles = () => {
  const { data: session } = useSession();

  const getRoles = () => {
    const userRole = session?.user.defaultRole;
    if (!userRole) {
      return [];
    }
    return getAvailableRoles(userRole);
  };

  const roles = getRoles();
  const isAdmin = !!roles?.includes(Role.Admin);

  return { roles, isAdmin };
};

export default useUserRoles;
